import { PasswordSettings } from '../../admin/types'
import { PasswordInvalidObject, PasswordInvalidTypes } from '../types'

const passwordRegExpList: { [key in PasswordInvalidTypes]?: RegExp } = {
  [PasswordInvalidTypes.SpecialCharacters]: /^(?=.*[!@#$%^&*])/,
  [PasswordInvalidTypes.MixedCase]: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/,
  [PasswordInvalidTypes.LowerCase]: /^(?=.*[a-z])/,
  [PasswordInvalidTypes.UpperCase]: /^(?=.*[A-Z])/,
  [PasswordInvalidTypes.AlphaNumeric]: /^(?=.*\d)/,
}

export const passwordValidation = (
  password: string,
  settings: PasswordSettings | undefined,
  t: CallableFunction
): string => {
  if (settings === undefined) {
    return ''
  }
  if (!password) {
    return t(PasswordInvalidTypes.Empty)
  }
  if (password.length < settings.minimum_length) {
    return t(PasswordInvalidTypes.MinimumLength, { minimumLength: settings.minimum_length })
  }
  if (settings.special_characters) {
    if (!passwordRegExpList[PasswordInvalidTypes.SpecialCharacters]?.test(password)) {
      return t(PasswordInvalidTypes.SpecialCharacters)
    }
  }
  if (settings.mixed_case) {
    if (!passwordRegExpList[PasswordInvalidTypes.MixedCase]?.test(password)) {
      return t(PasswordInvalidTypes.MixedCase)
    }
  }
  if (settings.alpha_numeric) {
    if (!passwordRegExpList[PasswordInvalidTypes.AlphaNumeric]?.test(password)) {
      return t(PasswordInvalidTypes.AlphaNumeric)
    }
  }

  return ''
}

export const detailedPasswordValidation = (
  password: string,
  settings: PasswordSettings | undefined
): PasswordInvalidObject => {
  if (settings === undefined) return {} as PasswordInvalidObject

  return {
    [PasswordInvalidTypes.Empty]: !password,
    [PasswordInvalidTypes.UpperCase]:
      settings.mixed_case && !passwordRegExpList[PasswordInvalidTypes.UpperCase]?.test(password),
    [PasswordInvalidTypes.LowerCase]:
      settings.mixed_case && !passwordRegExpList[PasswordInvalidTypes.LowerCase]?.test(password),
    [PasswordInvalidTypes.MinimumLength]: settings.minimum_length > 0 && password.length < settings.minimum_length,
    [PasswordInvalidTypes.AlphaNumeric]:
      settings.alpha_numeric && !passwordRegExpList[PasswordInvalidTypes.AlphaNumeric]?.test(password),
    [PasswordInvalidTypes.SpecialCharacters]:
      settings.special_characters && !passwordRegExpList[PasswordInvalidTypes.SpecialCharacters]?.test(password),
  }
}
